import { IRegularInfrastructureType } from '../../../types/map';

export const getFirstInfrastructureType = (infrastructureTypes: IRegularInfrastructureType[] | null) => {
  if (infrastructureTypes) {
    return infrastructureTypes[0].type;
  }

  return undefined;
};
